import React from 'react';
import { get, isNil } from 'lodash';
import { TOAST_TYPES } from 'components/common_v2/toasts';
import { isReadOnly } from 'utilities/user/permissions';
import { useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import {
  SuspendedPaymentMethod,
  NoPaymentMethod,
  PendingApproval,
  ApproachingCreditLimit,
  OverCreditLimit
} from './components';

const WarningIcon = () => {
  const theme = useTheme();
  return (<FontAwesomeIcon icon={icon({ name: 'triangle-exclamation' })} style={{ color: theme.palette.alert.warning.icon }} />);
};
const ErrorIcon = () => {
  const theme = useTheme();
  return (<FontAwesomeIcon icon={icon({ name: 'circle-exclamation' })} style={{ color: theme.palette.alert.error.icon }} />);
};

export const getAlertBannerContent = (user) => {
  if (get(user, 'customer.overCreditLimit')) {
    return {
      message: <OverCreditLimit user={user} />,
      type: TOAST_TYPES.CUSTOM,
      icon: <ErrorIcon />,
      severity: 'error',
    };
  }

  if (!isReadOnly(user) && isNil(get(user, 'paymentMethod'))) {
    return {
      message: <NoPaymentMethod user={user} />,
      type: TOAST_TYPES.CUSTOM,
      icon: <ErrorIcon />,
      severity: 'warning',
      'data-test-id': 'toast__warning'
    };
  }

  if (get(user, 'paymentMethod.suspend')) {
    return {
      message: <SuspendedPaymentMethod user={user} />,
      type: TOAST_TYPES.CUSTOM,
      icon: <ErrorIcon />,
      severity: 'error'
    };
  }

  if (get(user, 'customer.approachingCreditLimit')) {
    return {
      message: <ApproachingCreditLimit user={user} />,
      type: TOAST_TYPES.CUSTOM,
      icon: <WarningIcon />,
      severity: 'warning'
    };
  }

  if (get(user, 'customer.pendingApproval')) {
    return {
      message: <PendingApproval />,
      type: TOAST_TYPES.CUSTOM,
      icon: <WarningIcon />,
      severity: 'warning'
    };
  }

  return null;
};
